"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIALOG_WIDTH = 310;
exports.DIALOG_WIDTH_WIDER = 325;



//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/constants/dimensions.js
// module id = 619
// module chunks = 14